module.exports = __webpack_public_path__ + "static/chris-liebing-21f75b2a47f11fbc95958e7590b31dd8.png";